const genders = [
  {
    id:    'user_gender_male',
    value: 'male',
    label: 'Masculino',
  },
  {
    id:    'user_gender_female',
    value: 'female',
    label: 'Feminino',
  },
];
export default genders;
